module.exports = __webpack_public_path__ + "img/logo-solveit.b5756c26.svg";